/**
 * Z-Index Layer System
 *
 * This file defines a centralized z-index scale to prevent layering conflicts.
 * Use these constants instead of arbitrary z-index values.
 *
 * Layer Hierarchy (from bottom to top):
 * - BACKGROUND: Behind everything, for pseudo-elements
 * - BASE: Default layer (z-index: 0)
 * - CONTENT: Regular content overlays (tabs, icons, badges)
 * - DROPDOWN: Dropdown menus, date pickers, select menus
 * - STICKY: Sticky positioned elements (table headers, sticky navs)
 * - FIXED: Fixed positioned elements (sidebar navigation)
 * - OVERLAY: Overlays that cover main content (expanded search, filters)
 * - MODAL_BACKDROP: Background masks for modals
 * - MODAL: Modal dialogs and popups
 * - POPOVER: Popovers and context menus
 * - TOAST: Toast notifications
 * - TOOLTIP: Tooltips (highest priority UI elements)
 */

export const Z_INDEX = {
  // Background layer
  BACKGROUND: -1,

  // Base layers (0-10)
  BASE: 0,
  CONTENT: 1,
  CONTENT_2: 2,

  // Interactive elements (10-30)
  DROPDOWN: 10,
  STICKY: 20,
  FIXED: 30,

  // Overlays (40-100)
  OVERLAY: 40,
  MODAL_BACKDROP: 50,
  MODAL: 100,

  // High priority (200-1000)
  POPOVER: 200,
  TOAST: 300,
  TOOLTIP: 1000,
};

/**
 * Component-specific z-index mappings
 * These help document which components should use which layer
 */
export const COMPONENT_Z_INDEX = {
  // Base content
  avatar: Z_INDEX.BASE,
  badge: Z_INDEX.CONTENT,
  icon: Z_INDEX.CONTENT_2,
  tabs: Z_INDEX.CONTENT_2,

  // Interactive elements
  dropdown: Z_INDEX.DROPDOWN,
  datePicker: Z_INDEX.DROPDOWN,
  select: Z_INDEX.DROPDOWN,
  tableHeader: Z_INDEX.STICKY,
  navbar: Z_INDEX.FIXED,

  // Overlays
  searchBarExpanded: Z_INDEX.OVERLAY,
  filterPanel: Z_INDEX.OVERLAY,
  mask: Z_INDEX.MODAL_BACKDROP,
  popup: Z_INDEX.MODAL,
  modal: Z_INDEX.MODAL,

  // High priority
  contextMenu: Z_INDEX.POPOVER,
  overflowPopup: Z_INDEX.TOOLTIP,
  tooltip: Z_INDEX.TOOLTIP,
};

export default Z_INDEX;
